import { useState, useEffect } from 'react';

export const REASONS = {
  validFrom: 'validFrom',
  validTo: 'validTo',
};

function usePlayerIsBlocked(asset) {
  const { validFrom, validTo } = asset;
  const [isBlocked, setIsBlocked] = useState(false);
  const [reason, setReason] = useState('');

  useEffect(() => {
    const currentDate = new Date();

    if (validFrom && currentDate < new Date(validFrom)) {
      setReason(REASONS.validFrom);
      setIsBlocked(true);
    } else if (validTo && currentDate > new Date(validTo)) {
      setReason(REASONS.validTo);
      setIsBlocked(true);
    } else {
      setReason('');
      setIsBlocked(false);
    }
  }, [validFrom, validTo]);

  return { isBlocked, reason };
}

export default usePlayerIsBlocked;
